var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVerifiedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0,0,256,256",
    width: "24px",
    height: "24px",
    fillRule: "nonzero",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fillOpacity: 0.6,
    fill: "#000000",
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "",
    strokeDashoffset: 0,
    fontFamily: "none",
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      mixBlendMode: "normal"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "scale(10.66667,10.66667)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.228,12l0.622,-1.92c0.465,-1.437 -0.182,-3 -1.527,-3.687l-1.797,-0.918l-0.918,-1.797c-0.687,-1.345 -2.25,-1.993 -3.687,-1.527l-1.921,0.621l-1.92,-0.622c-1.437,-0.465 -3,0.182 -3.687,1.527l-0.919,1.797l-1.797,0.919c-1.345,0.687 -1.992,2.25 -1.527,3.687l0.622,1.92l-0.622,1.92c-0.465,1.437 0.182,3 1.527,3.687l1.797,0.918l0.918,1.797c0.687,1.345 2.25,1.993 3.687,1.527l1.921,-0.621l1.92,0.622c1.437,0.465 3,-0.182 3.687,-1.527l0.918,-1.797l1.797,-0.918c1.345,-0.687 1.993,-2.25 1.527,-3.687zM10.293,15.707l-2.293,-2.293c-0.39,-0.39 -0.39,-1.024 0,-1.414v0c0.39,-0.39 1.024,-0.39 1.414,0l1.586,1.586l4.586,-4.586c0.39,-0.39 1.024,-0.39 1.414,0v0c0.39,0.39 0.39,1.024 0,1.414l-5.293,5.293c-0.39,0.39 -1.024,0.39 -1.414,0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerifiedIcon);
export default __webpack_public_path__ + "static/media/Verified-Icon.8f45d502a2394d8b71f91dfa9a56248b.svg";
export { ForwardRef as ReactComponent };